/**
 * Notifica errores HTTP del servidor (5xx) o fallos de red (sin respuesta, p. ej. backend parado)
 * para mostrar el banner de soporte.
 * Usa un patrón pub/sub para que servicios sin acceso a React puedan disparar el aviso.
 */

export function isHttpServerError(status) {
  return typeof status === 'number' && status >= 500 && status < 600;
}

const listeners = new Set();

function broadcastSupportBanner() {
  listeners.forEach((cb) => {
    try {
      cb();
    } catch (e) {
      console.error(e);
    }
  });
}

export function subscribeSupportApiBanner(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

/**
 * Errores típicos cuando no hay respuesta HTTP: conexión rechazada, CORS, DNS, timeout de red, etc.
 */
export function isLikelyUnreachableApiError(error) {
  if (!error || error.name === 'AbortError') return false;
  const msg = String(error.message || '');
  const name = error.name || '';
  if (name === 'TypeError' && (/fetch/i.test(msg) || /Load failed/i.test(msg))) return true;
  if (msg.includes('Failed to fetch')) return true;
  if (msg.includes('NetworkError')) return true;
  if (msg.includes('Network request failed')) return true;
  if (msg.includes('Load failed')) return true;
  if (msg.includes('ECONNREFUSED') || msg.includes('ETIMEDOUT') || msg.includes('ENOTFOUND')) return true;
  if (msg.includes('Error de conexión') || msg.includes('Connection error')) return true;
  if (msg.includes('tardó demasiado')) return true;
  return false;
}

export function notifySupportApiServerError(status) {
  if (!isHttpServerError(status)) return;
  broadcastSupportBanner();
}

export function notifySupportApiNetworkError(error) {
  if (!isLikelyUnreachableApiError(error)) return;
  broadcastSupportBanner();
}

export function isSupportBannerForced() {
  return import.meta.env.VITE_FORCE_SUPPORT_ERROR_BANNER === 'true';
}
